export enum TranslationsEn {
  YEAR_MONTH_DAY = '{year}-{month}-{day}',
  MON = 'Mon',
  TUE = 'Tue',
  WED = 'Wed',
  THU = 'Thu',
  FRI = 'Fri',
  SAT = 'Sat',
  SUN = 'Sun',
  STREET_ADDRESS1 = 'Address 1',
  STREET_ADDRESS2 = 'Address 2',
  CITY = 'City',
  STATE = 'State',
  ZIP_CODE = 'Zip',
  COUNTRY = 'Country',
  OK = 'Ok',
  CANCEL = 'Cancel',
  CONFIRMATION = 'Confirmation',
  ARE_YOU_SURE_YOU_WANT_TO_CANCEL = 'Are you sure you want to cancel?',
  STEP = 'Step',
  OF = 'of',
  PREVIOUS = 'Previous',
  NEXT = 'Next',
  SUBMIT = 'Submit',
  CLOSE = 'Close',
  ENLARGED_ATTACHMENT = 'Enlarged attachment',
  NO_INFO = 'No information',
  BEDROOMS = 'Bedrooms',
  BATHROOMS = 'Bathrooms',
  HOME = 'Home',
  PROGRESS = 'Progress',
  START_DATE = 'Start date',
  END_DATE = 'End date',
  UNKNOWN = 'Unknown',
  VIEW_ALL = 'View all',
  FEET = 'ft',
  SUCCESS = 'Success!',
  FINISH = 'Finish',
  SOMETHING_WENT_WRONG = 'Oops! Something went wrong!',
  EMAIL = 'Email',
  UPLOAD_FILE = 'Upload file',
  BACK = 'Back',
  TENANT_SIGN_IN = 'Tenant portal',
  NO_RENTAL_HISTORY_ERROR = 'Please enter details for at least one prior rental.',
  REMOVE = 'Remove',
  APPLICANT_INFORMATION = 'Applicant information',
  POTENTIAL_UNITS = 'Potential units',
  UNITS_OF_INTEREST = 'Units of interest',
  ALL_UNITS = 'All units',
  OPEN_TO_ALL_UNITS = 'Open to all units',
  RENTAL_HISTORY = 'Rental history',
  WORK_HISTORY = 'Work history and income verification',
  TERM_AND_CONDITIONS = 'Terms and conditions',
  CONFIRM_YOUR_IDENTITY = 'Confirm your identity',
  PETS_AND_CARS = 'Pets and cars',
  QUESTIONS = 'Questions',
  RENTAL_APPLICATION = 'Rental application',
  SUBMIT_A_RENTAL_APPLICATION = 'Submit a rental application',
  MAGICDOOR_TERMS = 'MagicDoor Terms and Conditions',
  TRANS_UNION_TERMS = 'TransUnion Terms and Conditions',
  ADD_RENTAL_HISTORY = 'Add rental history',
  REASON_FOR_LEAVING = 'Reason for leaving',
  LANDLORD_NAME = 'Landlord name',
  LANDLORD_PHONE = 'Landlord phone',
  RENT = 'Rent',
  MOVE_IN_DATE = 'Move-in date',
  MOVE_OUT_DATE = 'Move-out date',
  I_HAVE_READ_AND_AGREED_TO_THE_TERMS = 'I have read and agreed to the terms of service',
  ADD_EMPLOYMENT = 'Add employment',
  EMPLOYMENT_HISTORY = 'Employment history',
  ANNUAL_INCOME = 'Annual income',
  NAME = 'Name',
  PHONE = 'Phone',
  POSITION = 'Position',
  JOB_TITLE = 'Job title',
  SALARY = 'Salary',
  START_SCREENING = 'Start screening',
  PAYMENT_DETAILS = 'Payment details',
  SUBMIT_ANSWERS = 'Submit answers',
  PAYMENT_PROCESSING = 'Payment processing ...',
  PAYMENT_PROCESSING_BLURB = "Your transaction is being processed. This may take a couple of minutes. Please sit tight and don't close your screen",
  DONE = 'Done',
  RENTAL_APPLICATION_SUCCESSFULLY_SUBMITTED = 'Your rental application was successfully submitted!',
  RENTAL_APPLICATION_NOTIFICATION = 'The application status will be notified by email. Please check your email.',
  CONNECTING_TO_TRANS_UNION = 'Connecting to TransUnion to Prepare Questionnaire and Initiate ID Verification ...',
  CONNECTING_TO_TRANS_UNION_BLURB = "Please hold on tight and don't leave this page - we're securely fetching your questionnaire and setting up ID verification.",
  CONTACT_CUSTOMER_SUPPORT = 'For completing your screening process, please contact our customer support at ',
  CONTACT_CUSTOMER_SUPPORT_BLURB = 'While on the call, please remain on this screen for real-time updates. Once your call is complete, please stay on the page for next step.',
  UNABLE_TO_VERIFY_IDENTITY = 'We are unable to verify your identity online.',
  RENTER_SCREENING_ID = 'Renter screening ID= {renterID}',
  PAGE_NOT_FOUND = 'Page Not Found',
  PAGE_NOT_FOUND_BLURB_1 = 'Looks like you found the doorway to the great nothing, sorry about that.',
  PAGE_NOT_FOUND_BLURB_2 = 'Please visit our hompage to get where you need to go.',
  COMPANY_NOT_FOUND = "It looks like the page you're looking for doesn't exist. Please check the URL or contact your property manager for assistance.",
  FIRST_NAME = 'First name',
  LAST_NAME = 'Last name',
  SSN = 'SSN',
  DATE_OF_BIRTH = 'Date of birth',
  VIEW_IN_FULL_SCREEN = 'Open in new tab',
  WELCOME = 'Welcome',
  YOU_HAVE_TO_ACCEPT_THIS_LICENSE_AGREEMENT = 'You have to accept this license agreement',
  PAY = 'Pay',
  RENTAL_APPLICATION_FEE_BLURB = 'You are required to pay a non-refundable fee of {amount} to submit your application, that will go towards the screening costs.',
  TEXT_ONLY = 'Text only',
  LEASING = 'Leasing',
  CONFIRM = 'Confirm',
  END_DATE_IS_INVALID = 'End date is not valid',
  FIRST_NAME_IS_INVALID = 'First name is not valid',
  LAST_NAME_IS_INVALID = 'Last name is not valid',
  EMAIL_IS_INVALID = 'Email is not valid',
  PHONE_NUMBER_IS_INVALID = 'Phone number is not valid',
  DATE_OF_BIRTH_IS_INVALID = 'Date of birth is not valid',
  DATE_OF_BIRTH_IS_GREATER = 'Age cannot be greater than 125 years',
  DATE_OF_BIRTH_IS_LESSER = 'Age cannot be less than 18 years',
  ANNUAL_INCOME_IS_INVALID = 'Annual income is not valid',
  SSN_IS_INVALID = 'SSN is not valid',
  EMPLOYER_NAME_IS_INVALID = 'Employer name is not valid',
  SALARY_IS_INVALID = 'Salary is not valid',
  POSITION_TITLE_IS_INVALID = 'Position/title is not valid',
  START_DATE_IS_INVALID = 'Start date is not valid',
  END_DATE_IS_INVALID_EARLIER = 'End date cannot be earlier than start date',
  ADDRESS_IS_INVALID = 'Address is not valid',
  STREET_ADDRESS_1_IS_INVALID = 'Street address 1 is not valid',
  STREET_ADDRESS_2_IS_INVALID = 'Street address 2 is not valid',
  REASON_FOR_LEAVING_IS_INVALID = 'The length of the reason for leaving cannot exceed 500',
  CITY_IS_INVALID = 'City is not valid',
  STATE_IS_INVALID = 'State is not valid',
  ZIP_CODE_IS_REQUIRED = 'Zip code is required',
  ZIP_CODE_IS_INVALID = 'The U.S. zipcode must consist of 5 digits',
  COUNTRY_IS_INVALID = 'Country is not valid',
  LANDLORD_NAME_IS_INVALID = 'Landlord name is not valid',
  LANDLORD_PHONE_NUMBER_IS_INVALID = 'Landlord phone number is not valid',
  RENT_IS_INVALID = 'Rent is not valid',
  MOVE_IN_DATE_IS_INVALID = 'Move in date is not valid',
  MOVE_OUT_DATE_IS_INVALID = 'Move out date is not valid',
  MOVE_IN_DATE_IS_LATER = 'Move in date cannot be later than move out date',
  MOVE_OUT_DATE_IS_EARLIER = 'Move out date cannot be earlier than move in date',
  JOB_TITLE_IS_INVALID = 'Job title is not valid',
  FILE_IS_REQUIRED = 'File is required',
  COMPANY_NAME = 'Company name',
  FOLLOW_US = 'Follow us',
  PROPERTIES = 'Properties',
  CONTACT_US = 'Contact us',
  LET_US_GUIDE_YOUR_HOME = 'Let us guide your home',
  BANNER_TITLE = "Discover a place you'll love to live",
  SEARCH = 'Search',
  PROPERTY_FOR_YOU_TITLE = 'Property for you',
  PROPERTY_FOR_YOU_SUBTITLE = "Search and save a few homes you like and we'll find recommendations for you.",
  PINNED = 'Pinned',
  PRICE = 'Price',
  MIN = 'Min',
  MAX = 'Max',
  NO_MIN = 'no min',
  NO_MAX = 'no max',
  HOME_TYPE = 'Home type',
  BEDS_AND_BATHS = 'Beds & Baths',
  ANY = 'Any',
  SINGLE_FAMILY = 'Single Family',
  MULTI_FAMILY = 'Multi Family',
  COMMERCIAL = 'Commercial',
  CONDO = 'Condo',
  TOWN_HOUSE = 'Town House',
  RESET = 'Reset',
  CONTACT_MANAGER = 'Contact manager',
  PET = 'Pet',
  PETS = 'Pets',
  AC = 'A/C',
  PARKING = 'Parking',
  UTILITIES_INCLUDED = 'Utilities included',
  INTERIOR_AMENITIES = 'Interior amenities',
  OUTDOOR_AMENITIES = 'Outdoor amenities',
  COMMUNITY_AMENITIES = 'Community amenities',
  OUTDOOR = 'Outdoor',
  LISTED = 'Listed',
  MONTH = 'Month',
  SQFT = 'sqft',
  OVERVIEW = 'Overview',
  HOME_HIGHLIGHTS = 'Home highlights',
  FACTS_AND_FEATURES = 'Facts and features',
  LOCAL_INFORMATION = 'Local information',
  SELECT_PRICE = 'Select price',
  SELECT_HOME_TYPE = 'Select home type',
  SELECT_MOVE_IN_DATE = 'Select move in date',
  SLIDE_UP_TO_LOAD_MORE = 'Slide up to load more',
  APPLY = 'Apply',
  PROPERTY_DETAIL = 'Property Detail',
  ZERO_RESULTS_DESC = 'No results found for the given address. Please check the address and try again.',
  MAP_ERROR_DESC = 'An error occurred while loading the map. Please try again later.',
  SEARCH_FOR_YOUR_DREAM_HOME = 'Search for your dream home',
  ALL_RIGHTS_RESERVED = 'All rights reserved',
  WE_CURRENTLY_DO_NOT_HAVE_ANY_AVAILABLE_UNITS = "We currently don't have any available units, but you are always welcome to submit a rental application to us",
  PRIVACY_POLICY = 'Privacy policy',
  ACCEPT_TERMS_AND_CONDITIONS_PROCEED = 'Please accept the terms and conditions to proceed.',
  TERMS_OF_SERVICE = 'Terms of service',
  EQUAL_HOUSING_OPPORTUNITY = 'Equal housing opportunity',
  FILTER = 'Filter',
  FILTERS = 'Filters',
  SIGN_HERE = 'Sign here!',
  ALLOWED = 'Allowed',
  MONTHLY_PET_FEES = 'Monthly pet fees',
  NO_LIMIT = 'No limit',
  PET_DEPOSIT = 'Pet deposit',
  SMALL_WEIGHT = 'Small (under 22.0462 pounds)',
  MEDIUM_WEIGHT = 'Medium (22.0462 - 55.1156 pounds)',
  LARGE_WEIGHT = 'Large (55.1156 - 110.2311 pounds)',
  CATS = 'Cats',
  DOGS = 'Dogs',
  OTHER = 'Other',
  FISH = 'Fish',
  BIRDS = 'Birds',
  REPTILES = 'Reptiles',
  OTHERS = 'Others',
  ALL_ALLOWED = 'All allowed',
  DESIRED_MOVE_IN_DATE_IS_INVALID = 'Desired move in date is not valid',
  DESIRED_MOVE_IN_DATE = 'Desired move in date',
  CURRENT_UNIT_IS_UNLISTED = 'The unit you are currently applying for is unlisted and will return to the home page in 3 seconds.',
  PLEASE_ANSWER_THIS_QUESTION = 'Please answer this question',
  COMMENT_CANNOT_EXCEED = 'Comment must be less than 500 characters',
  YOU_CAN_ADD_A_COMMENT_TO_THE_MANAGER = 'You can add a comment to the manager',
  COMMENT = 'Comment',
  PET_NAME_IS_INVALID = 'Pet name is invalid',
  BREED_IS_INVALID = 'Breed is invalid',
  PET_WEIGHT_IS_INVALID = 'Pet weight is invalid',
  AGE_IS_INVALID = 'Age is invalid',
  GENDER_IS_INVALID = 'Gender is invalid',
  SPAY_NEUTER_STATUS_IS_INVALID = 'Spayed/Neutered status is invalid',
  SERVICE_ANIMAL_STATUS_IS_INVALID = 'Service animal status is invalid',
  EMOTIONAL_SUPPORT_ANIMAL_STATUS_IS_INVALID = 'Emotional support animal status is invalid',
  CAR_MAKE_IS_INVALID = 'Car make is invalid',
  MODEL_IS_INVALID = 'Model is invalid',
  YEAR_IS_INVALID = 'Year is invalid',
  LICENSE_PLATE_IS_INVALID = 'License plate is invalid',
  STATE_REGISTRATION_IS_INVALID = 'State registration is invalid',
  CAR_COLOR_IS_INVALID = 'Car color is invalid',
  YOU_HAVE_SUCCESSFULLY_SIGNED_THE_LEASE = 'You have successfully signed the lease. Keep an eye out for futher messages from us.',
  BREED = 'Breed',
  WEIGHT = 'Weight',
  AGE = 'Age',
  GENDER = 'Gender',
  CAR = 'Car',
  CAR_MAKE = 'Car make',
  MODEL = 'Model',
  YEAR = 'Year',
  LICENSE_PLATE = 'License plate',
  STATE_REGISTRATION = 'State registration',
  COLOR = 'Color',
  SPAYED_OR_NEUTERED = 'My pet is spayed/ neutered',
  SERVICE_ANIMAL = 'My pet is a service animal',
  EMOTIONAL_SUPPORT_ANIMAL = 'My pet is an emotional support animal',
  MM_DD_YYYY = 'MM/DD/YYYY',
  OPERATION_FAILED_PLEASE_TRY_AGAIN_LATER = 'Operation failed, please try again later',
  REMOVE_SELECTED = 'Remove selected',
  PURCHASE_RENTAL_INSURANCE = 'Purchase rental insurance',
  LINK_EXPIRED = 'Link expired',
  THE_LINK_HAS_EXPIRED_BUT_WE_VE_SENT_YOU_ANOTHER_ONE_TO_YOUR_REGISTERED_EMAIL_ADDRESS = "The link has expired, but we've sent you another one to your registered email address.",
  DO_YOU_HAVE_A_PET = 'Do you have a pet?',
  ADD_NEW_PET = 'Add a new pet',
  DO_YOU_HAVE_A_CAR = 'Do you have a car?',
  ADD_NEW_CAR = 'Add a new car',
  NO_UNITS_LISTED = 'Currently, there are no units listed',
  OR_LESS = 'or less',
  OR_MORE = 'or more',
  ANY_PRICE = 'Any price',
  NO_MORE_RESULTS = 'No more results',
  BY_SUBMITTING_THIS_APPLICATION_BLURB = `By submitting this form, you are giving {companyName} your consent to receive account notifications, and direct communications messages from the company, at the provided number, including messages sent by autodialer. Message frequency may vary. Consent is not a condition of purchase. Message and data rates may apply. Unsubscribe at any time by replying STOP. Reply HELP for help. `,
  SEARCH_UNITS = 'Search units...',
  OOPS = 'Oops!',
  APPLY_NOW = 'Apply now',
}
